import { render, staticRenderFns } from "./Barcode.vue?vue&type=template&id=5b3c0dbb"
import script from "./Barcode.vue?vue&type=script&lang=ts"
export * from "./Barcode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports